module.exports = __webpack_public_path__ + "static/media/IP.259de733.svg";